export default __webpack_public_path__ + "static/media/default_user.0a5d79d7.png";